export default {
  'RequestListing.noNew': {
    en: 'You have no past requests',
    fr: "Vous n'avez pas de demandes passées",
  },
};
